var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.07617 10.7207C3.27637 10.877 3.53027 10.8232 3.83301 10.6035L6.41602 8.7041L9.00391 10.6035C9.30664 10.8232 9.55566 10.877 9.76074 10.7207C9.96094 10.5693 10.0049 10.3203 9.88281 9.96387L8.8623 6.92676L11.4697 5.05176C11.7725 4.83691 11.8945 4.6123 11.8164 4.36816C11.7383 4.13379 11.5088 4.0166 11.1328 4.02148L7.93457 4.04102L6.96289 0.989258C6.8457 0.62793 6.66992 0.447266 6.41602 0.447266C6.16699 0.447266 5.99121 0.62793 5.87402 0.989258L4.90234 4.04102L1.7041 4.02148C1.32812 4.0166 1.09863 4.13379 1.02051 4.36816C0.9375 4.6123 1.06445 4.83691 1.36719 5.05176L3.97461 6.92676L2.9541 9.96387C2.83203 10.3203 2.87598 10.5693 3.07617 10.7207Z",
    fill: "#F29937"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.9e4e21c6ec3d68718bf5b0093b9de4ab.svg";
export { ForwardRef as ReactComponent };